export enum GigOfferStages {
  NEW = 1,
  DECLINED_BY_FREELANCER = 2,
  DECLINED_BY_CUSTOMER = 3,
  ACCEPTED_BY_FREELANCER = 4,
  ACCEPTED_BY_CUSTOMER = 5,
  ESCROWED = 6,
}
